const adminEmails = new Set([
  "dano@ramtracking.com",
  "brent@ramtracking.com",
  "antonyr@ramtracking.com",
  "niallw+rl@ramtracking.com",
  "calluml@ramtracking.com",
  "amenaw@ramtracking.com",
  "kais@ramtracking.com",
  "benjaminw@ramtracking.com",
  "richardb@ramtracking.com",
  "jamie.richards@ramtracking.com",
  "patrickb@ramtracking.com",
]);

export const hasAccessToCustomerMedia = (email?: string): boolean => {
  return email ? adminEmails.has(email) : false;
};
